<template>
  <div v-if="!hasPermission('List Customer')">Você não tem permissão para acessar esta página!</div>
  <div v-else>
    <Toolbar />
    <div class="container-xxl">
    <div class="card">
      <div class="card-header">
        <div class="card-title">
          <div class="d-flex align-items-center position-relative my-1">
            <span class="svg-icon svg-icon-1 position-absolute ms-6">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <rect opacity="0.5" x="17.0365" y="15.1223" width="8.15546" height="2" rx="1"
                      transform="rotate(45 17.0365 15.1223)" fill="black"></rect>
                <path
                    d="M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z"
                    fill="black"></path>
              </svg>
            </span>
            <input type="text" data-kt-user-table-filter="search" v-model="search"
                   class="form-control form-control-solid w-250px ps-14"
                   placeholder="Pesquisar ...">
          </div>
        </div>
        <div class="card-toolbar">
          <button v-if="hasPermission('Store Customer')" class="btn btn-flex btn-primary m-1" data-bs-toggle="modal"
                  title="Novo cliente" data-bs-target="#modal_store_customer"
                  @click="resetFormStore">
            <i class="bi bi-plus-lg"></i> Adicionar
          </button>
        </div>
      </div>
      <div class="card-body py-4">
        <table class="table table-row-bordered gy-5">
          <thead>
          <tr class="fw-bold fs-6 text-muted">
            <th>Nome</th>
            <th>Tipo</th>
            <th>Documento</th>
            <th>E-mail</th>
            <th>Telefone</th>
            <th>Ativo</th>
            <th>Ações</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="customer in customersFiltered" :key="customer.id">
            <td>{{ customer.name }}</td>
            <td>
              <span class="badge badge-info">
                {{ customer.type === 'individual' ? 'Pessoa Física' : 'Pessoa Jurídica' }}
              </span>
            </td>
            <td>{{ customer.document || '-' }}</td>
            <td>{{ customer.email || '-' }}</td>
            <td>{{ customer.phone || customer.cellphone || '-' }}</td>
            <td>
              <span :class="customer.active ? 'badge badge-success' : 'badge badge-danger'">
                {{ customer.active ? 'Sim' : 'Não' }}
              </span>
            </td>
            <td>
              <button v-if="hasPermission('Update Customer')" type="button" class="btn btn-icon btn-bg-light btn-active-color-primary me-1"
                      data-bs-toggle="modal"
                      data-bs-target="#modal_edit_customer"
                      @click="onClickBtnEdit(customer)"
                      title="Editar">
                <i class="bi bi-pencil-square"></i>
              </button>
              <button v-if="hasPermission('Delete Customer')" class="btn btn-icon btn-bg-light btn-active-color-primary me-1"
                      @click="deleteCustomer(customer.id)"
                      data-bs-toggle="tooltip"
                      title="Excluir">
                <i class="bi bi-trash"></i>
              </button>
            </td>
          </tr>
          <tr v-if="customersFiltered.length === 0">
            <td colspan="7" class="text-center text-muted py-10">
              Nenhum cliente cadastrado
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Modal Store -->
    <div class="modal fade" tabindex="-1" id="modal_store_customer" data-bs-backdrop="static">
      <div class="modal-dialog modal-xl">
        <form method="post" @submit.prevent="submitFormStore">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Novo Cliente</h5>
              <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal"
                   aria-label="Fechar">
                <i class="bi bi-x-lg"></i>
              </div>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="mb-6">
                    <label for="name_store" class="required form-label">Nome</label>
                    <input type="text" class="form-control form-control-solid" id="name_store"
                           placeholder="Nome completo ou razão social"
                           v-model="formStore.name" required>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-6">
                    <label for="type_store" class="required form-label">Tipo de Cadastro</label>
                    <select class="form-control form-control-solid" id="type_store" v-model="formStore.type" required>
                      <option value="individual">Pessoa Física</option>
                      <option value="company">Pessoa Jurídica</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-6">
                    <label for="document_store" class="form-label">{{ formStore.type === 'individual' ? 'CPF' : 'CNPJ' }}</label>
                    <input type="text" class="form-control form-control-solid" id="document_store"
                           :placeholder="formStore.type === 'individual' ? '000.000.000-00' : '00.000.000/0000-00'"
                           v-mask="formStore.type === 'individual' ? '###.###.###-##' : '##.###.###/####-##'"
                           v-model="formStore.document">
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-6">
                    <label for="email_store" class="form-label">E-mail</label>
                    <input type="email" class="form-control form-control-solid" id="email_store"
                           placeholder="email@exemplo.com"
                           v-model="formStore.email">
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-6">
                    <label for="phone_store" class="form-label">Telefone</label>
                    <input type="text" class="form-control form-control-solid" id="phone_store"
                           placeholder="(00) 0000-0000"
                           v-mask="['(##) ####-####', '(##) #####-####']"
                           v-model="formStore.phone">
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-6">
                    <label for="cellphone_store" class="form-label">Celular</label>
                    <input type="text" class="form-control form-control-solid" id="cellphone_store"
                           placeholder="(00) 00000-0000"
                           v-mask="'(##) #####-####'"
                           v-model="formStore.cellphone">
                  </div>
                </div>
                <div class="col-md-12">
                  <hr class="my-4">
                  <h6 class="mb-4">Endereço</h6>
                </div>
                <div class="col-md-3">
                  <div class="mb-6">
                    <label for="zipcode_store" class="form-label">CEP</label>
                    <input type="text" class="form-control form-control-solid" id="zipcode_store"
                           placeholder="00000-000"
                           v-mask="'#####-###'"
                           v-model="formStore.zipcode"
                           @blur="getZipCode('store')">
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-6">
                    <label for="street_store" class="form-label">Rua/Logradouro</label>
                    <input type="text" class="form-control form-control-solid" id="street_store"
                           placeholder="Rua, Avenida, etc."
                           v-model="formStore.street">
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="mb-6">
                    <label for="number_store" class="form-label">Número</label>
                    <input type="text" class="form-control form-control-solid" id="number_store"
                           placeholder="123"
                           v-model="formStore.number">
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-6">
                    <label for="complement_store" class="form-label">Complemento</label>
                    <input type="text" class="form-control form-control-solid" id="complement_store"
                           placeholder="Apt, Bloco, etc."
                           v-model="formStore.complement">
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-6">
                    <label for="neighborhood_store" class="form-label">Bairro</label>
                    <input type="text" class="form-control form-control-solid" id="neighborhood_store"
                           placeholder="Nome do bairro"
                           v-model="formStore.neighborhood">
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-6">
                    <label for="state_store" class="form-label">Estado</label>
                    <select class="form-control form-control-solid" id="state_store"
                            @change="getCitiesFromState('store', $event.target.value)"
                            v-model="formStore.state_id">
                      <option value="">Selecione o estado</option>
                      <option :value="state.id_state" v-for="state in states">
                        {{ state.state_name }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-6">
                    <label for="city_store" class="form-label">Cidade</label>
                    <select class="form-control form-control-solid" id="city_store"
                            v-model="formStore.city_id">
                      <option value="">Selecione a cidade</option>
                      <option :value="city.id_city" v-for="city in citiesFromState">
                        {{ city.city_name }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="mb-6">
                    <label for="notes_store" class="form-label">Observações</label>
                    <textarea class="form-control form-control-solid" id="notes_store"
                              rows="3" placeholder="Observações sobre o cliente"
                              v-model="formStore.notes"></textarea>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-check form-check-custom form-check-solid">
                    <input class="form-check-input" type="checkbox"
                           v-model="formStore.active" id="active_store" checked/>
                    <label class="form-check-label" for="active_store">
                      Ativo
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-light" data-bs-dismiss="modal">Fechar</button>
              <button type="submit" class="btn btn-primary">Cadastrar</button>
            </div>
          </div>
        </form>
      </div>
    </div>

    <!-- Modal Edit -->
    <div class="modal fade" tabindex="-1" id="modal_edit_customer" data-bs-backdrop="static">
      <div class="modal-dialog modal-xl">
        <form method="post" @submit.prevent="submitFormEdit">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Editar Cliente</h5>
              <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal"
                   aria-label="Fechar">
                <i class="bi bi-x-lg"></i>
              </div>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="mb-6">
                    <label for="name_edit" class="required form-label">Nome</label>
                    <input type="text" class="form-control form-control-solid" id="name_edit"
                           placeholder="Nome completo ou razão social"
                           v-model="formEdit.name" required>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-6">
                    <label for="type_edit" class="required form-label">Tipo de Cadastro</label>
                    <select class="form-control form-control-solid" id="type_edit" v-model="formEdit.type" required>
                      <option value="individual">Pessoa Física</option>
                      <option value="company">Pessoa Jurídica</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-6">
                    <label for="document_edit" class="form-label">{{ formEdit.type === 'individual' ? 'CPF' : 'CNPJ' }}</label>
                    <input type="text" class="form-control form-control-solid" id="document_edit"
                           :placeholder="formEdit.type === 'individual' ? '000.000.000-00' : '00.000.000/0000-00'"
                           v-mask="formEdit.type === 'individual' ? '###.###.###-##' : '##.###.###/####-##'"
                           v-model="formEdit.document">
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-6">
                    <label for="email_edit" class="form-label">E-mail</label>
                    <input type="email" class="form-control form-control-solid" id="email_edit"
                           placeholder="email@exemplo.com"
                           v-model="formEdit.email">
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-6">
                    <label for="phone_edit" class="form-label">Telefone</label>
                    <input type="text" class="form-control form-control-solid" id="phone_edit"
                           placeholder="(00) 0000-0000"
                           v-mask="['(##) ####-####', '(##) #####-####']"
                           v-model="formEdit.phone">
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-6">
                    <label for="cellphone_edit" class="form-label">Celular</label>
                    <input type="text" class="form-control form-control-solid" id="cellphone_edit"
                           placeholder="(00) 00000-0000"
                           v-mask="'(##) #####-####'"
                           v-model="formEdit.cellphone">
                  </div>
                </div>
                <div class="col-md-12">
                  <hr class="my-4">
                  <h6 class="mb-4">Endereço</h6>
                </div>
                <div class="col-md-3">
                  <div class="mb-6">
                    <label for="zipcode_edit" class="form-label">CEP</label>
                    <input type="text" class="form-control form-control-solid" id="zipcode_edit"
                           placeholder="00000-000"
                           v-mask="'#####-###'"
                           v-model="formEdit.zipcode"
                           @blur="getZipCode('edit')">
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-6">
                    <label for="street_edit" class="form-label">Rua/Logradouro</label>
                    <input type="text" class="form-control form-control-solid" id="street_edit"
                           placeholder="Rua, Avenida, etc."
                           v-model="formEdit.street">
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="mb-6">
                    <label for="number_edit" class="form-label">Número</label>
                    <input type="text" class="form-control form-control-solid" id="number_edit"
                           placeholder="123"
                           v-model="formEdit.number">
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-6">
                    <label for="complement_edit" class="form-label">Complemento</label>
                    <input type="text" class="form-control form-control-solid" id="complement_edit"
                           placeholder="Apt, Bloco, etc."
                           v-model="formEdit.complement">
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-6">
                    <label for="neighborhood_edit" class="form-label">Bairro</label>
                    <input type="text" class="form-control form-control-solid" id="neighborhood_edit"
                           placeholder="Nome do bairro"
                           v-model="formEdit.neighborhood">
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-6">
                    <label for="state_edit" class="form-label">Estado</label>
                    <select class="form-control form-control-solid" id="state_edit"
                            @change="getCitiesFromState('edit', $event.target.value)"
                            v-model="formEdit.state_id">
                      <option value="">Selecione o estado</option>
                      <option :value="state.id_state" v-for="state in states">
                        {{ state.state_name }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-6">
                    <label for="city_edit" class="form-label">Cidade</label>
                    <select class="form-control form-control-solid" id="city_edit"
                            v-model="formEdit.city_id">
                      <option value="">Selecione a cidade</option>
                      <option :value="city.id_city" v-for="city in citiesFromStateEdit">
                        {{ city.city_name }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="mb-6">
                    <label for="notes_edit" class="form-label">Observações</label>
                    <textarea class="form-control form-control-solid" id="notes_edit"
                              rows="3" placeholder="Observações sobre o cliente"
                              v-model="formEdit.notes"></textarea>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-check form-check-custom form-check-solid">
                    <input class="form-check-input" type="checkbox"
                           v-model="formEdit.active" id="active_edit"/>
                    <label class="form-check-label" for="active_edit">
                      Ativo
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-light" data-bs-dismiss="modal">Fechar</button>
              <button type="submit" class="btn btn-primary">Salvar</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import http from "@/helpers/http";
import Alert from "@/helpers/alert";
import Permission from "@/helpers/permission";
import Toolbar from "@/components/layouts/auth/Toolbar.vue";
import {mask} from "vue-the-mask";

export default {
  name: "Customer",
  directives: {
    mask,
  },
  components: {
    Toolbar,
  },
  data() {
    return {
      search: '',
      customers: [],
      states: [],
      citiesFromState: [],
      citiesFromStateEdit: [],
      formStore: {
        name: '',
        type: 'individual',
        document: '',
        email: '',
        phone: '',
        cellphone: '',
        zipcode: '',
        street: '',
        number: '',
        complement: '',
        neighborhood: '',
        city_id: null,
        state_id: null,
        notes: '',
        active: true,
      },
      formEdit: {
        id: null,
        name: '',
        type: 'individual',
        document: '',
        email: '',
        phone: '',
        cellphone: '',
        zipcode: '',
        street: '',
        number: '',
        complement: '',
        neighborhood: '',
        city_id: null,
        state_id: null,
        notes: '',
        active: true,
      },
    }
  },
  computed: {
    place() {
      return this.$store.state.auth.place;
    },
    customersFiltered() {
      return this.customers.filter(customer => {
        return customer.name.toLowerCase().includes(this.search.toLowerCase()) ||
               (customer.document && customer.document.toLowerCase().includes(this.search.toLowerCase())) ||
               (customer.email && customer.email.toLowerCase().includes(this.search.toLowerCase()))
      })
    },
  },
  mounted() {
    this.loadCustomers();
    this.getStates();
  },
  methods: {
    hasPermission(permission) {
      return Permission.has(permission);
    },
    loadCustomers() {
      http.get(`/places/${this.place.id_place}/finances/customers`).then((response) => {
        this.customers = response.data;
      }).catch(() => {
        this.customers = [];
      });
    },
    getStates() {
      http.get(`/states`).then((response) => {
        this.states = response.data;
      });
    },
    getCitiesFromState(form, stateId) {
      if (!stateId) {
        if (form === 'store') {
          this.citiesFromState = [];
          this.formStore.city_id = null;
        } else {
          this.citiesFromStateEdit = [];
          this.formEdit.city_id = null;
        }
        return;
      }
      http.get(`/states/${stateId}/cities`).then((response) => {
        if (form === 'store') {
          this.citiesFromState = response.data;
          this.formStore.city_id = null;
        } else {
          this.citiesFromStateEdit = response.data;
        }
      });
    },
    getZipCode(form) {
      const zipcode = form === 'store' ? this.formStore.zipcode : this.formEdit.zipcode;
      if (!zipcode || zipcode.replace(/-/g, '').length < 8) {
        return;
      }
      http.get(`zipcode/` + zipcode.replace(/-/g, '')).then((response) => {
        if (form === 'store') {
          this.formStore.street = response.data.address;
          this.formStore.neighborhood = response.data.neighborhood;
          this.formStore.state_id = response.data.state?.id_state;
          if (this.formStore.state_id) {
            this.getCitiesFromState('store', this.formStore.state_id);
            setTimeout(() => {
              this.formStore.city_id = response.data.city?.id_city;
            }, 300);
          }
        } else {
          this.formEdit.street = response.data.address;
          this.formEdit.neighborhood = response.data.neighborhood;
          this.formEdit.state_id = response.data.state?.id_state;
          if (this.formEdit.state_id) {
            this.getCitiesFromState('edit', this.formEdit.state_id);
            setTimeout(() => {
              this.formEdit.city_id = response.data.city?.id_city;
            }, 300);
          }
        }
      }).catch((e) => {
        console.log(e.response);
      });
    },
    resetFormStore() {
      this.formStore = {
        name: '',
        type: 'individual',
        document: '',
        email: '',
        phone: '',
        cellphone: '',
        zipcode: '',
        street: '',
        number: '',
        complement: '',
        neighborhood: '',
        city_id: null,
        state_id: null,
        notes: '',
        active: true,
      };
      this.citiesFromState = [];
    },
    submitFormStore() {
      http.post(`/places/${this.place.id_place}/finances/customers`, this.formStore).then(() => {
        this.loadCustomers();
        Alert.toastSuccess("Cliente cadastrado com sucesso.");
        this.resetFormStore();
        bootstrap.Modal.getInstance(document.getElementById('modal_store_customer')).hide();
      }).catch(e => {
        Alert.toastError(e.response?.data?.message || "Erro ao cadastrar cliente.");
      });
    },
    submitFormEdit() {
      http.put(`/places/${this.place.id_place}/finances/customers/${this.formEdit.id}`, this.formEdit).then(() => {
        this.loadCustomers();
        Alert.toastSuccess("Cliente atualizado com sucesso.");
        bootstrap.Modal.getInstance(document.getElementById('modal_edit_customer')).hide();
      }).catch(e => {
        Alert.toastError(e.response?.data?.message || "Erro ao atualizar cliente.");
      });
    },
    onClickBtnEdit(customer) {
      this.formEdit = {
        id: customer.id,
        name: customer.name,
        type: customer.type,
        document: customer.document || '',
        email: customer.email || '',
        phone: customer.phone || '',
        cellphone: customer.cellphone || '',
        zipcode: customer.zipcode || '',
        street: customer.street || '',
        number: customer.number || '',
        complement: customer.complement || '',
        neighborhood: customer.neighborhood || '',
        city_id: customer.city_id,
        state_id: customer.state_id,
        notes: customer.notes || '',
        active: customer.active !== false,
      };
      if (this.formEdit.state_id) {
        this.getCitiesFromState('edit', this.formEdit.state_id);
      }
    },
    deleteCustomer(id) {
      Swal.fire({
        title: 'Tem certeza?',
        text: "Esta ação não pode ser desfeita!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim, excluir!',
        cancelButtonText: 'Cancelar',
        customClass: {
          confirmButton: "btn btn-danger",
          cancelButton: 'btn btn-secondary'
        }
      }).then((result) => {
        if (result.isConfirmed) {
          http.delete(`/places/${this.place.id_place}/finances/customers/${id}`).then(() => {
            this.loadCustomers();
            Alert.toastSuccess("Cliente excluído com sucesso.");
          }).catch(e => {
            Alert.toastError(e.response?.data?.message || "Erro ao excluir cliente.");
          });
        }
      });
    },
  }
}
</script>

<style scoped>
</style>

